"use client";
import { ROUTES } from "@/constants/routes";
import LogoSvg from "@/logo.svg";
import Link from "next/link";
import { Copyright } from "./Copyright";
import { ScrollLink } from "@/components/shared/ScrollLink";

export function Footer() {
  return (
    <footer data-theme="dark" className="bg-[#292A2D] text-[#C7C6CA]">
      <div className="container-responsive flex flex-col gap-10">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
          {/* logo */}
          <Link href={ROUTES.home} title="Home">
            <LogoSvg className="w-48 dark:text-white" />
          </Link>

          {/* links */}
          <div className="flex flex-col gap-14 md:flex-row">
            {/* resources */}
            <div className="flex flex-col gap-4">
              <h1 className="font-semibold">Resources</h1>
              {[
                { title: "Blog", link: ROUTES.blogs },
                // { title: "FAQ", link: ROUTES.faq },
              ].map((item, index) => (
                <Link key={index} href={item.link}>
                  {item.title}
                </Link>
              ))}
            </div>

            {/* company */}
            <div className="flex flex-col gap-4">
              <h1 className="font-semibold">Company</h1>
              {[
                { title: "About Us", link: ROUTES.aboutUs },
                { title: "Privacy & Policy", link: ROUTES.privacyPolicy },
                { title: "Terms and Conditions", link: ROUTES.termsAndConditions },
                { title: "Cookie Policy", link: ROUTES.home },
              ].map((item, index) => (
                <Link key={index} href={item.link}>
                  {item.title}
                </Link>
              ))}
            </div>

            {/* support */}
            <div className="flex flex-col gap-4">
              <h1 className="font-semibold">Support</h1>
              {[{ title: "Contact Us", link: ROUTES.contactUs }].map((item, index) => (
                <Link key={index} href={item.link}>
                  {item.title}
                </Link>
              ))}
              {[{ title: "FAQ", link: `/#${ROUTES.faq}` }].map((item, index) => (
                <ScrollLink
                  key={index}
                  // className={`text-center text-base font-normal`}
                  role="button"
                  href={`${item.link}`}
                  title={item.title}>
                  {item.title}
                </ScrollLink>
              ))}
            </div>
          </div>
        </div>

        <Copyright />
      </div>
    </footer>
  );
}
